































import { Component, Prop } from 'vue-property-decorator';
import { DxDataGrid, DxColumn } from 'devextreme-vue/data-grid';
import { DataSource } from '@/types';
import {
    Table,
    TableConfig,
    defaultTableConfig,
    columnTemplates,
} from '@/core/components/table';
import { localize } from '@/core/filters';
import Vue from 'vue';
import { Site } from '@/dto';
@Component({
    components: {
        DxDataGrid,
        DxColumn,
    },
})
export default class LocationHistoryTable extends Vue {
    @Prop({ type: String, required: true }) public tableKey!: string;
    @Prop({ type: Object, required: true }) public dataSource!: DataSource;
    @Prop({ type: Array, required: true }) public sites!: Site[];
    private minDestination = 400;

    public get tableConfig(): Partial<TableConfig> {
        return {
            ...defaultTableConfig(this),
        };
    }

    public async mounted() {
        // raise instance of the table up to parent
        this.$emit('setTableInstance', this.tableInstance);
    }

    public get tableInstance(): Table {
        const element = this.$refs['data-grid'] as unknown;
        return (element as DxDataGrid).instance!;
    }

    public get columnTemplates() {
        return columnTemplates;
    }

    public get localize() {
        return localize;
    }

    public getDataGridInstance(): Table {
        const element = this.$refs['data-grid'] as unknown;
        return (element as DxDataGrid).instance!;
    }
}
